import script from "./SearchSuggestions.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchSuggestions.vue?vue&type=script&setup=true&lang=js"

import "./SearchSuggestions.vue?vue&type=style&index=0&id=1cffeec6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cffeec6"]])

export default __exports__